import { FC, PropsWithChildren } from "react";
import { classes, style } from "typestyle";

interface IProps {
  type: "error" | "warning";
}

export const Alert: FC<PropsWithChildren<IProps>> = (props) => (
  <div className={classes(styles.alert, styles[props.type])}>
    {props.children}
  </div>
);

const styles = {
  alert: style({
    padding: "12px 16px",
    borderRadius: "8px",
    fontSize: ".8em",
  }),
  error: style({
    backgroundColor: "#f8d7da",
    borderColor: "#f5c6cb",
    color: "#721c24",
  }),
  warning: style({
    backgroundColor: "#fff3cd",
    borderColor: "#ffeeba",
    color: "#856404",
  }),
};
